module.exports = __webpack_public_path__ + "static/media/Jeniffer_Garcia_Martinez.3ca97169.jpg";